var ImportMappingDataItem = /** @class */ (function () {
    function ImportMappingDataItem() {
        this.intectColumnsDropDownDataSource = [];
        this.columnsTypeDropDownDataSource = [];
        this.columnstypeValue = undefined;
        // private autoMapColumnType(): void {
        //     if (!this.columnsTypeDropDownDataSource) {
        //         return;
        //     }
        //     let columnType: MappingObject = this.findColumnTypeByName(
        //         this.userFileColumnHeader
        //     );
        //     if (!columnType) {
        //         return;
        //     }
        //     this.columnsTypeValue = columnType.Id;
        // }
        // private findColumnTypeByName(name: string): MappingObject {
        //     return this.columnsTypeDropDownDataSource.find(
        //         (ctype: MappingObject) => {
        //             return (
        //                 this.userFileColumnHeader &&
        //                 ctype.Name &&
        //                 this.userFileColumnHeader.trim().toLowerCase() ===
        //                     ctype.Name.trim().toLowerCase()
        //             );
        //         }
        //     );
        // }
    }
    Object.defineProperty(ImportMappingDataItem.prototype, "IsId", {
        get: function () {
            return this.isId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportMappingDataItem.prototype, "columnsTypeValue", {
        get: function () {
            return this.columnstypeValue;
        },
        set: function (value) {
            this.columnstypeValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportMappingDataItem.prototype, "columnsTypeKey", {
        get: function () {
            var id = this.columnsTypeValue;
            if (!id) {
                return '';
            }
            var columnTypeItem = this.findColumnTypeItem(id);
            if (!columnTypeItem) {
                return '';
            }
            return columnTypeItem.Key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImportMappingDataItem.prototype, "IntectColumnsValue", {
        get: function () {
            return this.intectColumnsValue;
        },
        set: function (value) {
            this.intectColumnsValue = value;
        },
        enumerable: true,
        configurable: true
    });
    ImportMappingDataItem.prototype.setIntectColumnDropDownDataSourceAndAutoMap = function (dataSource) {
        this.intectColumnsDropDownDataSource = dataSource;
    };
    ImportMappingDataItem.prototype.setColumnTypeDropDownDataSourceAndAutoMap = function (dataSource) {
        this.columnsTypeDropDownDataSource = dataSource;
        //// this.autoMapColumnType();
    };
    ImportMappingDataItem.prototype.findIntectColumnItem = function (value) {
        var dataSource = this.intectColumnsDropDownDataSource;
        if (!value || !dataSource || dataSource.length === 0) {
            return undefined;
        }
        var result;
        if (dataSource) {
            result = dataSource.find(function (val) {
                return val.Name === value;
            });
        }
        return result;
    };
    ImportMappingDataItem.prototype.findColumnTypeItem = function (id) {
        var dataSource = this.columnsTypeDropDownDataSource;
        if (!id || !dataSource || dataSource.length === 0) {
            return undefined;
        }
        var result;
        if (dataSource) {
            result = dataSource.find(function (val) {
                return val.Id === id;
            });
        }
        return result;
    };
    ImportMappingDataItem.prototype.findColumnTypeItemByKey = function (key) {
        var dataSource = this.columnsTypeDropDownDataSource;
        if (!key || !dataSource || dataSource.length === 0) {
            return undefined;
        }
        var result;
        if (dataSource) {
            result = dataSource.find(function (val) {
                return val.Key === key;
            });
        }
        return result;
    };
    ImportMappingDataItem.prototype.autoMapIntectColumn = function () {
        if (!this.intectColumnsDropDownDataSource) {
            return;
        }
        var intectColumn = this.findIntectColumnByName(this.userFileColumnHeader);
        if (!intectColumn) {
            return;
        }
        this.IntectColumnsValue = intectColumn.Id;
    };
    ImportMappingDataItem.prototype.findIntectColumnByName = function (name) {
        var _this = this;
        if (this.intectColumnsDropDownDataSource) {
            return this.intectColumnsDropDownDataSource.find(function (ctype) { return _this.userFileColumnHeader === ctype.Name; });
        }
        return undefined;
    };
    return ImportMappingDataItem;
}());
export { ImportMappingDataItem };
